var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Card, Container, Typography, Grid } from '../';
import * as S from './styles';
export var ComparisonToolCard = forwardRef(function ComparisonToolCard(_a, ref) {
    var after = _a.after, before = _a.before, body = _a.body, disabled = _a.disabled, emoji = _a.emoji, open = _a.open, title = _a.title, graph = _a.graph, variant = _a.variant, className = _a.className, style = _a.style, rest = __rest(_a, ["after", "before", "body", "disabled", "emoji", "open", "title", "graph", "variant", "className", "style"]);
    var renderHeading = !graph ? (title) : (React.createElement(Grid, { spacing: 'small', wrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center' },
        React.createElement(Grid.Item, null, title),
        React.createElement(Grid.Item, { style: { position: 'relative' } },
            React.createElement(S.GraphWrapper, { flex: true, alignItems: 'flex-end' }, graph))));
    return (React.createElement(Card, __assign({ heading: renderHeading, startAdornment: before, endAdornment: after, className: className, inverted: variant === 'heading', open: open && open, ref: ref, style: style, disabled: disabled }, rest),
        React.createElement(Container, { flex: true, alignItems: 'center' },
            emoji && (React.createElement(Container, { right: 'xsmall' },
                React.createElement(Typography, { as: 'span', variant: 'heading', size: 'large' }, emoji))),
            React.createElement(Typography, { size: 'medium', weight: 'regular', color: variant === 'heading' ? 'white' : undefined, inline: true }, body))));
});
ComparisonToolCard.defaultProps = {
    disabled: false,
    variant: 'default',
    open: false
};
ComparisonToolCard.displayName = 'ComparisonToolCard';
export default ComparisonToolCard;
//# sourceMappingURL=ComparisonToolCard.js.map